import React from "react";
export function Main({ children }: { children: React.ReactElement}) {
    return <div className="App-main">{children}</div>
}